import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder1 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import userImagePlaceholder2 from "@circle-react-shared/BuilderUI/Assets/user_6_image_placeholder.png";
import userImagePlaceholder3 from "@circle-react-shared/BuilderUI/Assets/user_7_image_placeholder.png";
import userImagePlaceholder4 from "@circle-react-shared/BuilderUI/Assets/user_8_image_placeholder.png";
import userImagePlaceholder5 from "@circle-react-shared/BuilderUI/Assets/user_9_image_placeholder.png";
import userImagePlaceholder6 from "@circle-react-shared/BuilderUI/Assets/user_10_image_placeholder.png";
import { TABLET_WIDTH } from "@circle-react-shared/BuilderUI/Canvas/constants";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createTestimonial2Block } from "@circle-react-shared/BuilderUI/DefaultBlocks/Testimonials/Testimonial2/Testimonial2DefaultData";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getBlockPrimaryStyleOptions } from "../../constants";

const cards = [
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder1,
      header: "Michael Trevez",
      description: "Marketing Director",
    },
    content:
      '"Growth Network gave me the structure I didn\'t know I needed. I went from scattered ideas to a complete course in eight weeks—and launched it with confidence. The support was unmatched."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder2,
      header: "Jennifer Lorel",
      description: "Startup Founder",
    },
    content:
      "\"What stood out was how practical everything felt. I didn't just learn—I built. Every session, template, and lab pushed me forward. It finally feels like I'm running a real education business.\"",
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder3,
      header: "Sophia Racheal",
      description: "Healthcare Executive",
    },
    content:
      '"From day one, Growth Network helped me shape my knowledge into something scalable. The system is clear, focused, and results-driven—ideal for any professional serious about doing this right."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder4,
      header: "James Walter",
      description: "Finance Professional",
    },
    content:
      "\"I used to feel overwhelmed by all of it—tech, curriculum, launch plans. Growth Network helped me rebuild using systems that made sense. It's the first time I've felt in control.\"",
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder5,
      header: "David Konstas",
      description: "Senior Engineer",
    },
    content:
      '"Before Growth Network, I had ideas. Now I have a structured course, a scalable system, and a real plan. I didn\'t just build something—I became the kind of educator I set out to be."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder6,
      header: "Aisha Meher",
      description: "Non-Profit Leader",
    },
    content:
      '"I\'ve tried other programs, but this one helped me finish and ship. The Growth Network system is smart, clear, and completely doable—even as a solo founder with a full plate."',
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock7",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Real leaders. Real progress.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
        createPBlock({
          text: "From executive pivots to professional breakthroughs, our coaching and community help members turn expertise into structured, scalable programs—built to last.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card =>
        createTestimonial2Block({
          content: card.content,
          userCard: {
            signedId: card.userCard.imageSignedId,
            placeholder: card.userCard.placeholder,
            header: card.userCard.header,
            description: card.userCard.description,
          },
        }),
      ),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
